import React, { Suspense, useRef } from 'react'
import { useRouter } from 'next/router'

import { base } from '../../styles/base/_allBase.styles'
import SEO from '../seo-head/seo-head'
import SectionOne from '../section-one/section-one.jsx'
import { HeaderTwoColumGrid } from '../header-w-two-column-grid/header-w-two-column-grid'
import { Header } from '../header/header'
import { Footer } from '../footer/footer.component.jsx'
import { InsetCarouselSection } from '../inset-carousel-section/inset-carousel-section'
import ImpactStats from '../impact-stats/impact-stats.component'
import ActionPanel from '../action-panel/action-panel.component'

const {
  GridItem_HeaderSection,
  GridContainer_Page_Layout,
  Page_Main_Grid_Container,
} = base

export function StandardContentPage({
  page,
  heroCtaHref,
  heroCtaLabel,
  heroCtaExternal = false,
}) {
  const sectionOneRef = useRef()
  const router = useRouter()
  const { data, seo } = page
  const header = data.header
  const contentModules = Object.values(data).filter(
    (module) => module && module._type !== 'header'
  )

  const renderModule = (module) => {
    switch (module._type) {
      case 'headerTwoColumText':
        return <HeaderTwoColumGrid data={module} staticLayout />
      case 'carousel':
        return (
          <InsetCarouselSection
            imageArray={module.images}
            ariaLabel="SBCA community programme photographs"
            moduleId={module._key}
          />
        )
      case 'impactStats':
        return <ImpactStats data={module} />
      case 'actionPanel':
        return <ActionPanel data={module} />
      default:
        return null
    }
  }

  return (
    <GridContainer_Page_Layout>
      <SEO seo={seo} router={router} header={header} />
      <GridItem_HeaderSection>
        <header ref={sectionOneRef}>
          <Header />
        </header>
      </GridItem_HeaderSection>
      <main>
        <Page_Main_Grid_Container>
          <Suspense fallback={<div>Loading...</div>}>
            <SectionOne
              header={header}
              ctaHref={heroCtaHref}
              ctaLabel={heroCtaLabel}
              ctaExternal={heroCtaExternal}
            />
            {contentModules.map((module) => (
              <React.Fragment key={module._key || module.name || module._type}>
                {renderModule(module)}
              </React.Fragment>
            ))}
          </Suspense>
          <Footer />
        </Page_Main_Grid_Container>
      </main>
    </GridContainer_Page_Layout>
  )
}

export default StandardContentPage
